var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10V6.4375M9.5 12.6406V12.6719M16.625 10C16.625 13.935 13.435 17.125 9.5 17.125C5.56497 17.125 2.375 13.935 2.375 10C2.375 6.06497 5.56497 2.875 9.5 2.875C13.435 2.875 16.625 6.06497 16.625 10Z",
    stroke: "#F96056",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleInfo);
export default __webpack_public_path__ + "static/media/RedCircleInfo.4622e3fb9dd75cfe6648dbe3c0209233.svg";
export { ForwardRef as ReactComponent };